import { gql } from "@apollo/client";

export const FETCH_SHOPIFY_ORDERS = gql`
  query GetShopifyOrders(
    $instance: String!
    $pageSize: Int
    $cursor: String
    $query: String
  ) {
    shopifyOrders(
      instance: $instance
      pageSize: $pageSize
      cursor: $cursor
      query: $query
    )
  }
`;
